<template>
  <div class="culture-page">
    <!-- 顶部操作栏 -->
    <div class="top-header">
      <h2>企业文化</h2>
      <template v-if="isDesktop">
        <el-radio-group v-model="currentLang" @change="handleLangChange">
          <el-radio-button v-for="item in languageList" :key="item.code" :label="item.code">{{ item.name }}</el-radio-button>
        </el-radio-group>
        <el-button type="primary" @click="handleAddCulture">添加</el-button>
      </template>
      <template v-else>
        <van-radio-group v-model="currentLang" @change="handleLangChange">
          <van-radio v-for="item in languageList" :key="item.code" :label="item.code">{{ item.name }}</van-radio>
        </van-radio-group>
        <van-button type="primary" @click="handleAddCulture">添加</van-button>
      </template>
    </div>
    
    <!-- 内容区域 -->
    <div class="content-container">
      <div class="intro-card">
        <div class="card-content">
          <template v-if="filteredCultureList.length === 0">
            <div class="empty-state">
              <el-empty :description="currentLang === 'zh' ? '暂无企业文化' : currentLang === 'en' ? 'No corporate culture' : '기업 문화가 없습니다'" />
            </div>
          </template>
          <template v-else>
            <el-table :data="filteredCultureList" style="width: 100%" v-if="isDesktop">
              <el-table-column prop="title" label="标题" width="200" />
              <el-table-column prop="content" label="内容" />
              <!-- 添加显示开关 -->
              <el-table-column prop="status" label="显示" width="180">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" active-text="显示" inactive-text="隐藏" @change="handleStatusChange(scope.row)" />
                </template>
              </el-table-column>
              
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="handleEditCulture(scope.row)">编辑</el-button>
                  <el-button size="small" type="danger" @click="handleDeleteCulture(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="mobile-culture-list">
              <div v-for="item in filteredCultureList" :key="item.id" class="mobile-culture-item">
                <div class="mobile-culture-title">{{ item.title }}</div>
                <div class="mobile-culture-content">{{ item.content }}</div>
                <div class="mobile-culture-actions">
                  <van-button size="small" type="primary" @click="handleEditCulture(item)">编辑</van-button>
                  <van-button size="small" type="danger" @click="handleDeleteCulture(item.id)">删除</van-button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    
    <!-- 添加/编辑企业文化对话框 -->
    <template v-if="isDesktop">
      <el-dialog
        :title="cultureDialogTitle"
        :visible.sync="cultureDialogVisible"
        width="500px"
        :before-close="handleClose"
      >
        <el-form :model="cultureForm" label-width="100px">
          <el-form-item label="标题">
            <el-input v-model="cultureForm.title" placeholder="请输入标题" />
          </el-form-item>

          <el-form-item label="内容">
            <el-input v-model="cultureForm.content" type="textarea" placeholder="请输入内容" />
          </el-form-item>
          <el-form-item label="语言">
            <el-select v-model="cultureForm.language_id" placeholder="请选择语言">
              <el-option v-for="item in languageList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose(function(){ cultureDialogVisible = false })">取消</el-button>
          <el-button type="primary" @click="handleSaveCulture">确定</el-button>
        </span>
      </el-dialog>
    </template>
    <template v-else>
      <van-popup
        v-model="cultureDialogVisible"
        position="bottom"
        :round="true"
        :style="{ height: '80%' }"
        :close-on-click-overlay="false"
      >
        <div class="popup-header">
          <h3>{{ cultureDialogTitle }}</h3>
          <van-icon name="cross" @click="handleClosePopup" />
        </div>
        <div class="popup-content">
          <van-form @submit="handleSaveCulture">
            <van-field
              v-model="cultureForm.title"
              label="标题"
              placeholder="请输入标题"
            />
            <van-field
              v-model="cultureForm.content"
              label="内容"
              placeholder="请输入内容"
              type="textarea"
              :rows="3"
            />
            <van-field label="语言">
              <van-picker
                v-model="cultureForm.language_id"
                :columns="languageColumns"
                show-toolbar
                title="选择语言"
              />
            </van-field>
            <van-field label="状态">
              <van-switch v-model="cultureForm.status" :active-value="1" :inactive-value="0" />
            </van-field>
            <van-button type="primary" native-type="submit" block>确定</van-button>
            <van-button type="default" block @click="handleClosePopup">取消</van-button>
          </van-form>
        </div>
      </van-popup>
    </template>
  </div>
</template>

<script>
import { getLanguage } from '@/api/public'
import { getCultureByLang, getCulture, addCulture, updateCulture, deleteCulture } from '@/api/website'
import { Dialog } from 'vant'

export default {
  name: 'CulturePage',
  data() {
    return {
      isDesktop: true,
      languageList: [],
      currentLang: 'zh',
      cultureDialogVisible: false,
      cultureDialogTitle: '',
      cultureForm: {
        id: null,
        title: '',
        content: '',
        language_id: '',
      },
      cultureList: [
        {
          id: 1,
          title: '企业使命',
          content: '致力于为客户提供最优质的产品和服务',
          language_id: 1,
          lang: 'zh',
          status: 1
        },
        {
          id: 2,
          title: '企业愿景',
          content: '成为行业领导者',
          language_id: 1,
          lang: 'zh',
          status: 1
        },
        {
          id: 3,
          title: 'Company Mission',
          content: 'Committed to providing customers with the highest quality products and services',
          language_id: 2,
          lang: 'en',
          status: 1
        },
        {
          id: 4,
          title: 'Company Vision',
          content: 'To become an industry leader',
          language_id: 2,
          lang: 'en',
          status: 1
        }
      ]
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkScreenSize)
    this.getLanguageList()
    this.getCultureList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  computed: {
    filteredCultureList() {
      return this.cultureList.filter(item => item.lang === this.currentLang)
    },
    languageColumns() {
      return this.languageList.map(item => ({
        text: item.name,
        value: item.id
      }))
    }
  },
  methods: {
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    getCultureList() {
      getCultureByLang(this.currentLang).then(res => {
        if(res.code === 200){
          this.cultureList = res.data || []
        }
      })
    },
    async getLanguageList() {
      try {
        const response = await getLanguage()
        this.languageList = response.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    handleAddCulture() {
      this.cultureDialogTitle = '添加企业文化'
      this.cultureForm = {
        id: 0,
        title: '',
        content: '',
        language_id: '',
      }
      this.cultureDialogVisible = true
    },
    handleEditCulture(item) {
      this.cultureDialogTitle = '编辑企业文化'
      this.cultureForm = {
        id: item.id,
        title: item.title,
        content: item.content,
        language_id: item.language_id,
        status: item.status
      }
      this.cultureDialogVisible = true
    },
    handleStatusChange(item) {
      updateCulture(item.id, { status: item.status }).then(() => {
        this.$message.success('状态更新成功')
      })
    },
    handleDeleteCulture(id) {
      this.$confirm('确定要删除吗？', '确定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCulture(id).then(() => {
          this.getCultureList()
          this.$message.success('删除成功')
        })
      }).catch(() => {})
    },
    handleSaveCulture() {
      // 验证表单
      if (!this.cultureForm.title || !this.cultureForm.content || !this.cultureForm.language_id) {
        this.$message.error('请填写完整信息')
        return
      }
      
      // 获取语言代码
      const language = this.languageList.find(item => item.id === this.cultureForm.language_id)
      const lang = language ? language.code : 'zh'
      
      const formData = {
        ...this.cultureForm,
        lang
      }
      
      if (formData.id) {
        // 编辑
        updateCulture(formData.id,formData).then(() => {
          this.getCultureList()
          this.$message.success('保存成功')
          this.cultureDialogVisible = false
        })
      } else {
        // 添加
        addCulture(formData).then(() => {
          this.getCultureList()
          this.$message.success('添加成功')
          this.cultureDialogVisible = false
        })
      }
    },
    handleLangChange() {
      // 语言切换逻辑
      this.getCultureList()
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(function() {
        done()
      }).catch(function() {})
    },
    handleClosePopup() {
      var vm = this
      Dialog.confirm({
        title: '提示',
        message: '确认关闭？',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        vm.cultureDialogVisible = false
      }).catch(function() {})
    }
  }
}
</script>

<style scoped lang="scss">
.culture-page {
  width: 100%;
  padding: 20px;
}

.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.top-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.content-container {
  min-height: 400px;
}

.intro-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f2f5;
}

.card-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.card-content {
  margin-bottom: 15px;
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  background-color: #f5f7fa;
  border-radius: 8px;
}

/* 移动端企业文化列表 */
.mobile-culture-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-culture-item {
  padding: 15px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background-color: #f5f7fa;
}

.mobile-culture-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

.mobile-culture-content {
  font-size: 14px;
  line-height: 1.5;
  color: #606266;
  margin-bottom: 10px;
}

.mobile-culture-actions {
  display: flex;
  gap: 10px;
}

/* 移动端弹出框样式 */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.popup-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.popup-content {
  padding: 16px;
  height: calc(100% - 60px);
  overflow-y: auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .culture-page {
    padding: 10px;
  }
  
  .top-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .intro-card {
    padding: 15px;
  }
}
</style>